export default () => {
  if (!$('[data-extra-seo]').length) {
    return;
  }
  
  $(document).on('click touchend', '[data-show-hide-seo]', () => {
    $('[data-show-hide-seo]').toggleClass('active');
    $('[data-extra-seo]').toggleClass('active');
  });
};
